import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { injectIntl } from 'react-intl';
import { compose, withProps } from 'recompose';

import { ImageManager } from '../ImageManager';
import Avatar from '../../Avatar';
import emptyAvatar from '../../../assets/images/empty-avatar.png';
import styles from './index.styl';

const AvatarWithCropModal = ({
  url,
  name,
  edit,
  onImageRemove,
  onImageCrop,
  bordered,
  size,
  formatMessage,
  offsetX,
  offsetY,
}) => {
  return (
    <div styleName="root">
      <Avatar
        children={name}
        src={name || url ? url : emptyAvatar}
        bordered={bordered}
        size={size}
      />
      <ImageManager
        removeTitle={formatMessage({ id: 'community.logo.removeTitle' })}
        cropTitle={formatMessage({ id: 'community.logo.cropTitle' })}
        onImageRemove={onImageRemove}
        onImageCrop={onImageCrop}
        hidden={!edit}
        style={{
          position: 'absolute',
          top: offsetY ? `${-offsetY}px` : 0,
          right: offsetX ? `${-offsetX}px` : 0,
        }}
        aspectRatio={1}
        rounded
      />
    </div>
  );
};

AvatarWithCropModal.defaultPros = {
  size: 100,
};

AvatarWithCropModal.propTypes = {
  onImageRemove: PropTypes.func.isRequired,
  onImageCrop: PropTypes.func.isRequired,
  edit: PropTypes.bool,
  formatMessage: PropTypes.func.isRequired,
  image: PropTypes.shape({
    url: PropTypes.string,
  }),
  url: PropTypes.string,
  name: PropTypes.string,
  bordered: PropTypes.bool,
  size: PropTypes.number,
  offsetX: PropTypes.number,
  offsetY: PropTypes.number,
};

export default compose(
  injectIntl,
  withProps(({ intl: { formatMessage } }) => ({
    formatMessage,
  })),
  CSSModules(styles, { allowMultiple: true }),
)(AvatarWithCropModal);



// WEBPACK FOOTER //
// ./src/components/common/AvatarWithCropModal/index.jsx